import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFtlLtl = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path fill="#616061" d="M7 1H1v4h6zM7 7H1v8h6zM9 1h6v8H9zM15 11H9v4h6z" />
  </svg>
);
export default SvgFtlLtl;
